<template>
  <div>
    <card class="w-100">
      <el-row :gutter="10">
        <form @submit.prevent="changePage(1)">
          <el-col :span="6">
            <div class="form-group">
              <label>업체구분</label>
              <el-select v-model="searchRoleCode">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  key="BUILDER"
                  value="BUILDER"
                  label="시공사"></el-option>
                <el-option
                  key="AGENT"
                  value="AGENT"
                  label="광고대행사"></el-option>
                <el-option
                  key="ADVERTISER"
                  value="ADVERTISER"
                  label="광고주"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label>업체명</label>
              <el-input v-model="searchName" placeholder="업체명">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
            </div>
          </el-col>
          <el-col :span="2">
            <div class="form-group">
            </div>
          </el-col>
          <el-col :span="4">
            <div class="pull-right-top24">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <el-col :span="24">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="$store.state.settingsCompany.company"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="companyName"
            label="업체명">
          </el-table-column>
          <el-table-column
            prop="licenseNumber"
            label="사업자번호">
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="업체구분">
          </el-table-column>
          <el-table-column
            label="관리"
            width="100">
            <template slot-scope="props">
              <el-button  icon="el-icon-edit" @click="handleEdit(props.$index, props.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <p-pagination class="pull-right"
                      v-on:input="changePage"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      :total="$store.state.settingsCompany.total">
        </p-pagination>
      </el-col>
    </card>
  </div>
</template>

<script>

    import Vue from 'vue'
    import {Table, TableColumn, Input, Button, Select, Option, Row, Col} from 'element-ui'
    import PPagination from 'src/components/UIComponents/Pagination.vue'

    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Input)
    Vue.use(Select)
    Vue.use(Option)

    export default {
        name: "SettingsCompany",
        components: {
            PPagination
        },
        created: function () {
            this.$store.dispatch('common/setMenuTitle', "업체 관리");
            this.changePage(1);
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            // 수정
            handleEdit(index, row) {
                Vue.router.push({name: 'SettingsCompanyRegistration', params: {companySeq : row.companySeq}});
            },
            register() {
                Vue.router.push({name: 'SettingsCompanyRegistration'})
            },
            changePage(item) {
                this.pagination.currentPage = item;
                let param = {
                    page: item,
                    searchName: this.searchName,
                    roleCode: this.searchRoleCode,
                    rows: this.pagination.perPage
                };
                this.$store.dispatch('settingsCompany/findAll', param);
            }
        },
        data() {
            return {
                searchName: null,
                searchRoleCode: "",
                pagination: {
                    perPage: 10,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                },
            }
        }
    }
</script>

<style scoped>

</style>
